/**
 * SQLite service using sql.js (WASM-based SQLite).
 * Adapted from previs-pro-web — read-only for timeline viewer.
 */

import type { Database, SqlJsStatic } from 'sql.js';

let SQL: SqlJsStatic | null = null;

/** Lazy-init sql.js WASM. Called once, cached thereafter. */
async function initSqlJs(): Promise<SqlJsStatic> {
  if (SQL) return SQL;

  const mod = await import('sql.js');

  if (location.protocol === 'file:') {
    // Emscripten's internal fetch rejects file:// responses (status 0, ok=false).
    // Pre-fetch the WASM binary ourselves and pass it directly.
    const resp = await fetch('sql-wasm.wasm');
    const wasmBinary = await resp.arrayBuffer();
    SQL = await mod.default({ wasmBinary } as Parameters<typeof mod.default>[0]);
  } else {
    SQL = await mod.default({
      locateFile: (file: string) => `${import.meta.env.BASE_URL}${file}`,
    });
  }
  return SQL;
}

/** Open an existing .previs database from raw bytes. */
export async function openDatabase(bytes: ArrayLike<number>): Promise<Database> {
  const sql = await initSqlJs();
  const db = new sql.Database(new Uint8Array(bytes));
  return db;
}

/** Close a database and free WASM memory. */
export function closeDatabase(db: Database): void {
  db.close();
}
